import { CLAIM_STATUSES } from 'containers/CourtManagerLegalProceedings/constants';

export const TOTAL_PAGES: number = 0;

export const TOTAL_CLAIMS_PER_PAGE: number = 5;

export const REQUEST_LAST_ASSIGNED_CLAIMS = 'REQUEST_LAST_ASSIGNED_CLAIM';

export const SET_LAST_ASSIGNED_CLAIMS = 'SET_LAST_ASSIGNED_CLAIM';

export const SET_SEARCH_QUERY = 'SET_SEARCH_QUERY';

export const SET_SELECTED_RESULT_SEARCH = 'SET_SELECTED_RESULT_SEARCH';

export const RESET_STORE_SEARCH = 'RESET_STORE_SEARCH';

export const sagisClaimStatuses = [
  CLAIM_STATUSES.ACTIVATION,
  CLAIM_STATUSES.CANCELED,
  CLAIM_STATUSES.CLOSED,
  CLAIM_STATUSES.FIXED,
  CLAIM_STATUSES.INPROGRESS,
  CLAIM_STATUSES.NOFOLLOWUP,
  CLAIM_STATUSES.PREACTIVATION,
  CLAIM_STATUSES.REOPEN,
];
